<p>
  admin-product-type works!
</p>
